import { IActionType } from "@monorepo/utils/src/eventBus/types/action";

export const formLoadingPayload = (name: string, filter: Record<string, unknown>): IActionType<Record<string, unknown>> => {
  return {
    name,
    payload: filter,
  };
};
